import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Panel from 'containers/time-poll/components/Panel'
import LoginPoll from 'containers/time-poll/components/LoginPoll'
import { routerActions } from 'react-router-redux'

import {
  showPhoneFieldSelector,
  showPhoneCodeFieldSelector,
  loginFormSelector
} from 'src/selectors'

export class LoginPhone extends React.Component {
  _formatPhoneNumber(phoneNumber) {
    const areaCode = phoneNumber.substr(1, 3)
    const prefix = phoneNumber.substr(4, 3)
    const suffix = phoneNumber.substr(7, 4)

    return `(${areaCode}) ${prefix}-${suffix}`
  }
  _getTitle = (showPhoneField, showPhoneCodeField) => {
    const { loginForm } = this.props
    const confirmNumber = {
      title: 'Confirm Number',
      subtitle:
        'A code was sent to ' +
        this._formatPhoneNumber(loginForm.phoneNumber) +
        '.' +
        ' Enter it here to verify your number'
    }
    const enterNumber = {
      title: 'Login/Create an Account',
      subtitle:
        'Login or Create an Account to create Polls & Lists. Say goodbye to endless group texts to coordinate. Your friends will thank you!'
    }
    if (showPhoneField) {
      return enterNumber
    }
    if (showPhoneCodeField) {
      return confirmNumber
    }
  }
  render() {
    const { showPhoneField, showPhoneCodeField, onNextStep, handleBackClick } = this.props
    const isSecondButton = true
    return (
      <Panel
        isSecondButton={isSecondButton}
        notification={this._getTitle(showPhoneField, showPhoneCodeField)}
        handleBackClick={handleBackClick}
        titleSize={{ title: '22px', subtitle: '14px' }}
        isLogin
      >
        <LoginPoll onNextStep={onNextStep} />
      </Panel>
    )
  }
}

LoginPhone.propTypes = {
  loginForm: PropTypes.object,
  showPhoneCodeField: PropTypes.bool,
  showPhoneField: PropTypes.bool,
  onNextStep: PropTypes.func,
  handleBackClick: PropTypes.func
}

function mapStateToProps(state) {
  const showPhoneCodeField = showPhoneCodeFieldSelector(state)
  const showPhoneField = showPhoneFieldSelector(state)
  const loginForm = loginFormSelector(state)
  return {
    loginForm,
    showPhoneCodeField,
    showPhoneField
  }
}

function mapDispatchToProps(dispatch) {
  return {
    goBack: () => dispatch(routerActions.goBack())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPhone)



// WEBPACK FOOTER //
// ./src/containers/time-poll/TimePollContainer/SignUp/SignUpDetail/LoginPhone/loginPhone.jsx